import { api } from 'api'
import { useQuery } from '@tanstack/react-query'

export const useFetchReferralTransferCustomer = (id: string) => {
  return useQuery({
    queryKey: ['referralTransferCustomer', id],
    queryFn: () => api.referral.fetchTransferCustomer(id),
    enabled: false, // Запрос выполняется только по требованию
  })
}
